import React, { useState } from "react";
import {
   Box,
   Button,
   ButtonProps,
   Link,
   Modal,
   styled,
   Typography,
   IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../css/register.css";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ReactLoading from "react-loading";
import Global from "../utils/global";

const style = {
   position: "absolute" as "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   // border: "2px solid #000",
   // borderradius: '10px',
   boxShadow: 24,
   p: 4,
};

const RegisterModal = ({ openModal, setOpenModal }: any) => {
   const navigate = useNavigate();
   //    const [openModal, setOpenModal] = useState(false);
   const handleOpenModal = () => setOpenModal(true);
   const handleClose = () => setOpenModal(false);
   const [userDetails, setUserDetails] = useState({});
   const [isLoading, setIsLoading] = useState(false);

   const [type, setType]: any = useState();
   const [open, setOpen] = useState(false);
   const [message, setMessage]: any = useState();

   const [state, setState] = useState({
      vertical: "top",
      horizontal: "center",
   });
   const { vertical, horizontal } = state;

   const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
      props,
      ref
   ) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
   });

   const registerHandler = async (userDetails: any) => {
      if (
         !userDetails.id ||
         !userDetails.name ||
         !userDetails.password ||
         !userDetails.email
      ) {
         console.log("here");
         setOpen(true);
         setType("warning");
         setMessage("Please provide all details.");
         return;
      }

      const validateEmail = (email: string) => {
         return String(email)
            .toLowerCase()
            .match(
               /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
      };

      if (!validateEmail(userDetails.email)) {
         console.log("here1");
         setOpen(true);
         setType("warning");
         setMessage("Please enter proper email.");
         return;
      }
      console.log({ userDetails });
      setIsLoading(true);
      try {
         const response = await fetch(`${Global.API_URL}/auth/register`, {
            method: "post",
            headers: {
               "content-type": "application/json",
               "authorization": "Bearer "+Global.token
            },
            body: JSON.stringify({
               id: userDetails.id,
               name: userDetails.name,
               password: userDetails.password,
               email: userDetails.email,
            }),
         });
         const data = await response.json();
         console.log("Registeration Data : ", data);
         if (data.user) {
            console.log("Successful Registration");
            setOpen(true);
            setType("success");
            setMessage("Successful Registration");
            setIsLoading(false);
            setUserDetails({});
            setOpenModal(false);
            //   navigate("/home");
         } else {
            console.log("Error");
            setOpen(true);
            setType("error");
            setMessage(data.message);
            setIsLoading(false);
            setIsLoading(false);
         }
      } catch (error: any) {
         console.log("Error in catch");
         setOpen(true);
         setType("error");
         setMessage("Something went wrong, please try again later!");
         setIsLoading(false);
         setIsLoading(false);
      }
   };

   const LoadingLoginButton = styled(LoadingButton)<ButtonProps>(() => ({
      color: "var(--buttonText)",
      backgroundColor: "var(--primary)",
      "&:hover": {
         backgroundColor: "var(--buttonHover)",
      },
   }));
   return (
      <div>
         <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={open}
            autoHideDuration={6000}
            onClose={() => {
               setOpen(false);
            }}
            key={vertical + horizontal}
         >
            <Alert severity={type}>{message}</Alert>
         </Snackbar>
         <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style} className="box">
               <div className="register-modal-header">
                  <Typography className="reg-text">Register</Typography>
                  <IconButton
                     aria-label="close"
                     style={{ alignSelf: "baseline" }}
                     onClick={handleClose}
                  >
                     <CloseIcon className="close-btn" />
                  </IconButton>
               </div>
               <div className="reg-form">
                  {/* <label className="l1">ID</label> */}
                  <input
                     className="id"
                     placeholder="Id"
                     type="text"
                     name="id"
                     onChange={(event: any) => {
                        console.log({ id: event.target.value });
                        setUserDetails({
                           ...userDetails,
                           id: event.target.value,
                        });
                     }}
                  />
                  ;{/* <label className="l2">Name</label> */}
                  <input
                     className="username"
                     placeholder="Name"
                     type="text"
                     name="name"
                     onChange={(event: any) => {
                        console.log({ name: event.target.value });
                        setUserDetails({
                           ...userDetails,
                           name: event.target.value,
                        });
                     }}
                     //   value={name}
                  />
                  ;{/* <label className="l3">Email</label> */}
                  <input
                     className="email"
                     placeholder="Email"
                     type="text"
                     name="email"
                     onChange={(event: any) => {
                        console.log({ email: event.target.value });
                        setUserDetails({
                           ...userDetails,
                           email: event.target.value,
                        });
                     }}
                  />
                  ;{/* <label className="l4">Password</label> */}
                  <input
                     className="password"
                     placeholder="Password"
                     type="password"
                     name="password"
                     onChange={(event: any) => {
                        console.log({ password: event.target.value });
                        setUserDetails({
                           ...userDetails,
                           password: event.target.value,
                        });
                     }}
                  />
                  {isLoading ? (
                     <ReactLoading
                        type="bubbles"
                        height={"15%"}
                        width={"15%"}
                        color="black"
                        className="loading-prop"
                     />
                  ) : (
                     <LoadingLoginButton
                        variant="contained"
                        loading={false}
                        className="reg-btn"
                        onClick={() => {
                           registerHandler(userDetails);
                        }}
                     >
                        <Typography className="reg-btn-text">Submit</Typography>
                     </LoadingLoginButton>
                  )}
               </div>
            </Box>
         </Modal>
      </div>
   );
};
export default RegisterModal;
// export default BasicModal;
